import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CheckboxIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 11.414L3.586 8L5 6.586L7 8.586L11 4.586L12.414 6L7 11.414Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34314 16 0 14.6569 0 13V3C0 1.34314 1.34315 0 3 0ZM3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3Z"
        />
      </svg>
    </Icon>
  );
}
